module.exports = __webpack_public_path__ + "static/media/placeholder.898297b2.png";